/**
 * DoAr Command Runtime — type constants.
 * Single source of truth for all intent/system/dimension/route strings.
 */

export const INTENTS = {
  CREATE_MODEL:      'CREATE_MODEL',
  EDIT_MODEL:        'EDIT_MODEL',
  PLACE_MODEL:       'PLACE_MODEL',
  GENERATE_IMAGE:    'GENERATE_IMAGE',
  GENERATE_VIDEO:    'GENERATE_VIDEO',
  CAPTURE_VIEWPOINT: 'CAPTURE_VIEWPOINT',
  CREATE_STORY:      'CREATE_STORY',
  PROJECT_BRIEF:     'PROJECT_BRIEF',
  SWITCH_DIMENSION:  'SWITCH_DIMENSION',
  GENERAL_CHAT:      'GENERAL_CHAT',
};

export const SYSTEMS = {
  ACTION_ENGINE:     'ACTION_ENGINE',
  SPATIAL_BRIEF:     'SPATIAL_BRIEF',
  VIEWPOINT_CAPTURE: 'VIEWPOINT_CAPTURE',
  IMAGE_GENERATION:  'IMAGE_GENERATION',
  VIDEO_GENERATION:  'VIDEO_GENERATION',
  DIMENSION_SWITCH:  'DIMENSION_SWITCH',
  GENERAL_CHAT:      'GENERAL_CHAT',
};

export const DIMENSIONS = {
  THOUGHT:  '1D',
  IMAGE:    '2D',
  VIDEO:    '2.5D',
  MODEL:    '3D',
  GEOSPACE: '3.5D',
  XR:       '4D',
};

export const ROUTES = {
  ACTION_ENGINE:         'ACTION_ENGINE',
  SPATIAL_BRIEF:         'SPATIAL_BRIEF',
  IMAGE_GENERATION:      'IMAGE_GENERATION',
  VIDEO_GENERATION:      'VIDEO_GENERATION',
  VIEWPOINT_CAPTURE:     'VIEWPOINT_CAPTURE',
  GENERAL_CHAT:          'GENERAL_CHAT',
  BLOCKED_NEEDS_CONTEXT: 'BLOCKED_NEEDS_CONTEXT',
  ERROR:                 'ERROR',
};

// Universal command categories — dimension-agnostic.
// Each dimension maps these to its own action handlers.
export const CMD = {
  CREATE:    'create',
  EDIT:      'edit',
  TRANSFORM: 'transform',
  PLACE:     'place',
  STYLE:     'style',
  ANALYZE:   'analyze',
  CAPTURE:   'capture',
  RENDER:    'render',
  ANIMATE:   'animate',
  PUBLISH:   'publish',
  EXPLAIN:   'explain',
  COMPARE:   'compare',
  CONTINUE:  'continue',
};
